var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivateCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.23363 8.19209C4.04419 8.19216 3.86146 8.12073 3.7224 7.99207L0.239494 4.74006C0.167267 4.67282 0.109106 4.59202 0.0681077 4.50227C0.027109 4.41251 0.00400933 4.31554 0.000480707 4.21693C-0.00304792 4.11831 0.0128771 4.01996 0.0473557 3.9275C0.0818343 3.83504 0.134172 3.75027 0.201408 3.67805C0.268645 3.60582 0.349687 3.54754 0.439446 3.50654C0.529204 3.46554 0.625986 3.44262 0.724602 3.43909C0.823218 3.43557 0.921693 3.45149 1.01415 3.48597C1.10661 3.52045 1.19119 3.57285 1.26342 3.64008L4.19164 6.37409L9.84545 0.203071C9.98365 0.0734016 10.166 0.000843342 10.3555 7.30651e-06C10.545 -0.000828729 10.7276 0.0701094 10.8669 0.198555C11.0063 0.327 11.0919 0.503442 11.1064 0.69239C11.121 0.881339 11.0636 1.06877 10.9455 1.21705L4.78149 7.94709C4.71457 8.01992 4.63394 8.07878 4.54418 8.12031C4.45442 8.16184 4.35736 8.18523 4.25854 8.18909L4.23363 8.19209Z",
    fill: "#00A0FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivateCheck);
export default __webpack_public_path__ + "static/media/activateCheck.9a1524fe17e39480c6d075bf8a74da45.svg";
export { ForwardRef as ReactComponent };